import b from 'b_';
import { format, isSameDay, isSameMinute } from 'date-fns';
import { Text } from 'platform-components';
import React from 'react';
import { connect } from 'react-redux';

import * as lessonSelectors from 'common.components/lesson/selectors';

import './side-panel__lesson-period.scss';

interface StoreProps {
    dateAssignment: Date | null;
    dateDeadline: Date | null;
    dateCompleted: Date | null;
}

interface Props extends StoreProps {}

export const LessonDate = ({ date, isForced }: { date: Date; isForced?: boolean }) => {
    return <span className={b('side-panel', 'lesson-period-date', { forced: isForced })}>{format(date, 'dd.MM')}</span>;
};

export const LessonTime = ({ date, isForced }: { date: Date; isForced?: boolean }) => {
    return <span className={b('side-panel', 'lesson-period-time', { forced: isForced })}>{format(date, 'HH:mm')}</span>;
};

// eslint-disable-next-line complexity
export const LessonPeriod = ({ dateAssignment, dateDeadline, dateCompleted }: Props) => {
    const endDate = dateCompleted || dateDeadline;

    if (dateAssignment && endDate && isSameDay(dateAssignment, endDate)) {
        return (
            <span className={b('side-panel', 'lesson-period')}>
                <Text id="lessonView.lessonPeriod.from" />
                <LessonDate date={dateAssignment} />
                <span className="side-panel__lesson-period-time">
                    <LessonTime date={dateAssignment} />
                    <Text id="lessonView.lessonPeriod.interval" />
                    <LessonTime
                        date={endDate}
                        isForced={Boolean(dateCompleted && !isSameMinute(dateDeadline!, dateCompleted))}
                    />
                </span>
            </span>
        );
    }

    return (
        <span className={b('side-panel', 'lesson-period')}>
            {dateAssignment && (
                <>
                    <Text id="lessonView.lessonPeriod.from" />
                    <LessonDate date={dateAssignment} />
                    <LessonTime date={dateAssignment} />
                </>
            )}
            {endDate && (
                <>
                    <Text id="lessonView.lessonPeriod.to" />
                    <LessonDate
                        date={endDate}
                        isForced={Boolean(dateCompleted && !isSameDay(dateDeadline!, dateCompleted))}
                    />
                    <LessonTime
                        date={endDate}
                        isForced={Boolean(dateCompleted && !isSameMinute(dateDeadline!, dateCompleted))}
                    />
                </>
            )}
        </span>
    );
};

const mapStateToProps = (storeState: any): StoreProps => {
    const dateAssignment = lessonSelectors.getLessonAssignmentDate(storeState);
    const dateDeadline = lessonSelectors.getLessonDeadlineDate(storeState);
    const dateCompleted = lessonSelectors.getLessonCompletedDate(storeState);

    return {
        dateAssignment: dateAssignment ? new Date(dateAssignment) : null,
        dateDeadline: dateDeadline ? new Date(dateDeadline) : null,
        dateCompleted: dateCompleted ? new Date(dateCompleted) : null,
    };
};

export default connect(mapStateToProps)(LessonPeriod);
